<template>
    <div class="vouch">
        <label>{{ vouchLabel }}</label>
        <textarea class="form-control input-lg" v-model="form.msg" @submit="submit" ref="textBox" rows="2"></textarea>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Form from 'Site/js/util/form';

export default {
    name: 'Vouch',
    computed: {
        ...mapState({
            config: state => state.config,
            t: state => state.t.profile.vouch,
        }),
        vouchLabel() {
            return this.t.vouch_for.replace('%username', this.config.data.userName);
        },
    },
    data() {
        return {
            form: new Form({
                msg: '',
                user: '',
            }, {
                msg: ['required'],
            }),
        };
    },
    methods: {
        submit() {
            this.form.user = this.config.data.userId;
            const form = this.form.create('vouch');
            if (form) {
                form.then((response) => {
                    this.$store.dispatch('notify', { msg: response.message });
                    this.$parent.$emit('hideModal');
                    this.$emit('vouched');
                    this.msg = '';
                }).catch(({ response }) => {
                    response.then((error) => {
                        this.$store.dispatch('notify', { type: 'error', msg: error.message });
                    });
                });
            }
        }
    },
    mounted() {
        this.$on('submit', this.submit);
    },
};
</script>
